var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuth0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 234,
    viewBox: "-11 -82 27 234",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 5,
    d: "M2.5 0v40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuth0);
export default __webpack_public_path__ + "static/media/auth0.6548bc0623d611d7572ed296990daa6f.svg";
export { ForwardRef as ReactComponent };